<template>
  <section class="section">
    <h2>
      Download do Logotipo
      <!-- <small
        >Escolha entre as opções com borda e sem borda e com o slogan ou sem o
        slogan.</small
      >
      <small
        >Depois clique no botão com o seu formato favorito para fazer o
        download.</small
      > -->
    </h2>
    <v-container grid-list-lg>
      <v-layout class="botoes" align-center justify-center row wrap fill-height>
        <v-flex xs4 sm3 md3 lg2>
          <v-switch
            color="primary"
            v-model="slogan"
            :label="slogan ? `Com slogan` : `Sem slogan`"
          ></v-switch>
        </v-flex>
        <v-flex xs4 sm3 md3 lg2>
          <v-switch
            color="primary"
            v-model="border"
            :label="border ? `Com borda` : `Sem borda`"
          ></v-switch>
        </v-flex>
      </v-layout>

      <v-layout align-center justify-center row wrap fill-height pt-4>
        <v-flex class="logo" xs10 sm8 md8 lg6>
          <img :src="logo.file + `.svg`" :alt="logo.title" style="width:100%" />
        </v-flex>
      </v-layout>

      <v-layout align-center justify-center row fill-height my-4>
        <v-flex xs12 style="text-align:center;">
          <v-btn
            large
            round
            color="orange"
            dark
            :href="logo.file + `.` + type"
            target="_blank"
            v-for="(type, i) in logo.types"
            :key="i"
          >
            <v-icon>get_app</v-icon>
            {{ type }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container grid-list-lg>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 sm10 md10 lg8>
          <p style="text-align:center !important;">
            O uso do logotipo oficial da Escola Engenho só poderá ser feito após
            autorização formal da direção e sempre respeitando o padrão de cores
            e formatos pré estabelecidos.
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    slogan: true,
    border: false,
    logos: [
      {
        title: "Logo com slogan e com borda",
        file: "/downloads/logos/logo-com-slogan-com-borda",
        slogan: true,
        border: true,
        types: ["png", "pdf", "svg", "ai"],
        color: "grey lighten-2"
      },
      {
        title: "Logo com slogan e sem borda",
        file: "/downloads/logos/logo-com-slogan-sem-borda",
        slogan: true,
        border: false,
        types: ["png", "pdf", "svg", "ai"],
        color: "grey lighten-3"
      },
      {
        title: "Logo sem slogan e com borda",
        file: "/downloads/logos/logo-sem-slogan-com-borda",
        slogan: false,
        border: true,
        types: ["png", "pdf", "svg", "ai"],
        color: "grey lighten-2"
      },
      {
        title: "Logo sem slogan e sem borda",
        file: "/downloads/logos/logo-sem-slogan-sem-borda",
        slogan: false,
        border: false,
        types: ["png", "pdf", "svg", "ai"],
        color: "grey lighten-3"
      }
    ]
  }),
  computed: {
    logo: function() {
      console.log("computed", this);
      let self = this;
      let logo = null;
      self.logos.forEach(function(l) {
        if (self.slogan === l.slogan && self.border === l.border) {
          logo = l;
        }
      });
      return logo;
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  background: repeating-linear-gradient(
    315deg,
    #e5e5e5,
    #f5f5f5 6px,
    #e5e5e5 6px,
    #f5f5f5 12px
  );
}
p,
h2 {
  text-align: center !important;
  small {
    display: block;
    font-size: 0.5em;
    line-height: 1.4em;
  }
}

.botoes {
  display: none;
}

.logo {
  background-color: #cacaca;
}
</style>
